import React from 'react';
import './committee.css';
import { CommitteeIcon } from '../../../../components/committee-icon';
import { Icon } from '../../../../components/icon';

const Committee = props => {
    const { committeeMembers, possibleMembers } = props;

    const placeholderLength = 6 - committeeMembers.length;

    return (
        <div className="committee">
            {committeeMembers.map(member => (
                <CommitteeIcon
                    key={member + 'icon'}
                    id={possibleMembers[member].id}
                    index={member}
                    size="small"
                />
            ))}
            {Array.from(Array(placeholderLength), (placeholder, i) => (
                <div className="committee-placeholder" key={i}>
                    <Icon iconName="caller-3" />
                </div>
            ))}
        </div>
    );
};

export { Committee };
